/**
 * Runs documentation page — executing agents, streaming, follow-ups, and polling.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { runsContent } from "@/constants/docs/runs";

export const Route = createFileRoute("/docs/runs")({
	component: RunsPage,
});

function RunsPage() {
	return <DocsPage title="Runs" content={runsContent} />;
}
